<div class="flex h-full flex-col overflow-y-auto lg:gap-5 xl:gap-6">
  @if (!!data) {
    <div class="flex flex-col">
      <h1 class="mb-4 ml-3 mt-5 text-2xl text-base-gray-500" translate>
        <span class="text-2xl font-semibold" translate>eclass.informacao</span> eclass.atividade
      </h1>
      <table app-table>
        <tbody>
          <tr>
            <td class="uppercase text-base-gray-400" app-table-cell translate>eclass.data-aula</td>
            <td app-table-cell>{{ data?.classDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <td class="bg-base-pacific-100! uppercase text-base-gray-400" app-table-cell translate>
              eclass.disciplina
            </td>
            <td app-table-cell class="bg-base-pacific-100!">{{ data?.subject }}</td>
          </tr>
          <tr>
            <td class="uppercase text-base-gray-400" app-table-cell translate>eclass.entregar-ate</td>
            @if (!!data.resubDate) {
              <td app-table-cell>
                {{ data?.resubDate | date: 'dd/MM/yyyy' }} {{ 'geral.ate' | translate }}
                {{ data?.resubDate | date: 'HH:mm:ss' }}
              </td>
            } @else {
              <td app-table-cell>
                {{ data?.deadLine | date: 'dd/MM/yyyy' }} {{ 'geral.ate' | translate }}
                {{ data?.deadLine | date: 'HH:mm:ss' }}
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-col">
      <h1 class="text-lg font-semibold text-base-gray-500">{{ data?.title }}</h1>
      @if (!!data?.content) {
        <app-text-editor class="block" [readOnly]="true" [value]="data?.content"></app-text-editor>
      }
    </div>
  } @else {
    <div style="height: 40vh">
      <app-skeleton></app-skeleton>
    </div>
  }
  <div class="mt-5 flex h-auto flex-col gap-2 overflow-y-auto">
    @for (file of data?.attachments; track file) {
      <div app-button class="mb-2 mt-2 flex w-full items-center justify-between! rounded-lg bg-white p-3 shadow-md">
        <div class="flex justify-start">
          <svg-icon class="mr-5 mt-1 w-8 min-w-[25px]" [src]="icon(file.extension)"></svg-icon>
          <div class="ml-1 grid">
            <div class="relative flex truncate hover:text-clip">
              <span class="whitespace-nowrap text-md font-semibold hover:animate-marquee">
                {{ file.title }}
              </span>
            </div>
            <span class="text-base text-base-gray-400">{{ file.updated_at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
          </div>
        </div>
        <div class="flex justify-end">
          @if (!!canDownload(file.extension)) {
            <svg-icon
              class="w-9 min-w-[16px] cursor-pointer pr-2 text-modules-eclass-500"
              (click)="onDownload(file.id)"
              src="assets/icons/icon-download.svg"
            ></svg-icon>
          }
          <svg-icon
            class="w-8 min-w-[16px] cursor-pointer pt-1 text-modules-eclass-500"
            (click)="onOpenFeedbackAttachment(file)"
            src="assets/icons/icon-eyes.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
</div>
